// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__gyY95","noInteraction":"EventWrapper_noInteraction__myhOi"};